{
  "version": 1,
  "asset_id": "4c58bb9c-e141-400f-a5ae-b8ba74e31173",
  "project_id": "81e5f51e-81a3-47ad-9e0d-7249ca4c0a70",
  "url": "/__l5e/assets-v1/4c58bb9c-e141-400f-a5ae-b8ba74e31173/neteller.svg",
  "r2_key": "a/v1/81e5f51e-81a3-47ad-9e0d-7249ca4c0a70/4c58bb9c-e141-400f-a5ae-b8ba74e31173/neteller.svg",
  "original_filename": "neteller.svg",
  "size": 1584,
  "content_type": "image/svg+xml",
  "created_at": "2026-08-30T15:11:49Z"
}
